/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { type ReactNode, type CSSProperties, useContext } from 'react';
import Highlighter from 'react-highlight-words';

import { SearchContext } from '../../contexts/SearchContext';

type HighlightSearchProps = {
	style?: CSSProperties;
	title?: string;
	children: string;
};

export function HighlightSearch( { style, title, children }: HighlightSearchProps ): ReactNode {
	const searchQuery = useContext( SearchContext );

	return (
		<Highlighter
			searchWords={ [ ...searchQuery.split( /[ -]/g ) ] }
			autoEscape={ true }
			textToHighlight={ children }
			highlightTag={ HighlightElement }
			style={ style }
			title={ title }
		/>
	);
}

function HighlightElement( { children }: { children: string } ): ReactNode {
	const { palette } = useTheme();

	return (
		<Typography
			component='span'
			fontSize='inherit'
			fontFamily='inherit'
			fontStyle='inherit'
			fontWeight='inherit'
			lineHeight='inherit'
			padding='1px 0'
			margin='0 1px'
			borderRadius='2px'
			sx={ {
				outline: `1px solid ${ palette.primary.main + '66' }`,
				backgroundColor: palette.primary.main + '33'
			} }
		>
			{ children }
		</Typography>
	);
}
